require('./iframe.component.scss');

export const IFrameComponent = {
  template  : require('./iframe.component.html'),
  bindings  : {
    src: '=',
  },
  controller: function ($scope) {

    // hooking up the onload event - calling the callback on load event
    // const onLoad = () => {
    //   const contentLocation = element.length > 0 && element[0].contentWindow ?
    //     element[0].contentWindow.location :
    //     undefined;
    //
    //   scope.callback({
    //     contentLocation
    //   });
    // };
    // element.on("load", onLoad);
    // scope.$on('$destroy', () => {
    //   element.off("load", onLoad);
    // });

  },
};



// WEBPACK FOOTER //
// ./src/shared/iframe.component.js